<template>
  <my-giving-layout :enable-scroll-event="true">
    <div class="bg-[#F6F4F0] h-full pb-[64px]">
      <BackButton class="w-full px-[20px] mb-[16px]" :customBack="back" />
      <h1 class="font-bold text-[1.5rem] leading-[2rem] ml-[28px] pb-[26px]">Contact Us</h1>
      <div
        class="text-[0.875rem] leading-[1.25rem] font-medium mx-[20px] p-[16px] rounded-2xl bg-[#FFFFFF]"
        v-html="description"
      />
    </div>
  </my-giving-layout>
</template>

<script>
import BackButton from '@/components/common/BackButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';

export default {
  components: { BackButton, MyGivingLayout },
  data() {
    return {
      description: `<p class="font-bold">For any enquiries, please contact our Accounts Team through the following channels:</p><br/>
        Email: <a href="mailto:accounts@heartofgodchurch.org" class="underline">accounts@heartofgodchurch.org</a><br/>
        Phone: <a href="tel:68462529" class="underline">68462529</a>`,
    };
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/my-giving');
      }
    },
  },
};
</script>
